import React, { useState } from "react";

import { useFormikContext } from "formik";

import { Select } from "clearsense-ui/components/formik";

import Fields from ".";

import { dataCy, snakeCaseToTitleCase } from "../../utils";

const NestedFields = ({ field, checkForDescription }) => {
  const [nestedFields, setNestedFields] = useState([]);

  const { setFieldValue } = useFormikContext();

  const handleChange = (option, key) => {
    const selectedValue = {
      ...option,
      value: findSelectedValue(option.value.properties, "const"),
    };
    setFieldValue(key, selectedValue);
    const specifications = Object.entries(option.value.properties);
    const fields = specifications.reduce((acc, [innerKey, specification]) => {
      if ("const" in specification) {
        return acc;
      }
      const field = {
        ...specification,
        key: `${key}.${innerKey}`,
        type: specification?.airbyte_secret ? "password" : specification.type,
        required: option.value.required?.includes(innerKey),
      };
      return [...acc, field];
    }, []);
    fields.sort((a, b) => a.order - b.order);
    setNestedFields(fields);
  };

  const findSelectedValue = (properties, keyToFind) => {
    const propertiesWithValues = Object.entries(properties);
    return propertiesWithValues.reduce(
      (acc, [outerKey, value]) =>
        Object.keys(value).includes(keyToFind)
          ? { ...acc, [outerKey]: value[keyToFind] }
          : acc,
      {}
    );
  };

  return (
    <div className="border-2 p-4 space-y-4 rounded">
      <Select
        key={field.key}
        name={field.key}
        label={field?.title ?? snakeCaseToTitleCase(field.key)}
        options={field?.oneOf?.map(option => ({
          label: option.title,
          value: { properties: option.properties, required: option?.required },
        }))}
        data-cy={`new-${dataCy(field.key)}-select`}
        onChange={option => handleChange(option, field.key)}
        helpText={checkForDescription(field?.description, field?.examples)}
      />
      {nestedFields.length > 0 && <Fields fields={nestedFields} />}
    </div>
  );
};

export default NestedFields;
